import { MyListingStatus } from '@kamernet/core/ApiClient/Kamernet';
import {
  parseRouteParamToEnum,
  parseRouteParamToInt,
} from '@kamernet/utilities/URL';

import { defineRoute } from '../defineRoute';

export const DEFAULT_PAGE_NO = 1;
export const DEFAULT_LISTING_STATUS = MyListingStatus.Active;
export const DEFAULT_SEARCH_TERM = '';

export type MyListingsRouteParams = {
  pageNo?: number | null;
  listingStatus?: MyListingStatus | null;
  searchTerm?: string | null;
};

export type MyListingsRouteParamsString = {
  pageNo?: string;
  listingStatus?: string;
  searchTerm?: string;
};

export const MyListings = defineRoute<
  MyListingsRouteParams,
  MyListingsRouteParamsString
>({
  pathname: '/my-adverts',
  nlPathname: '/mijn-advertenties',
  options: { isLandlordRoute: true, isPublic: false },
  routeParamsStringifier: routeParams => {
    return {
      pageNo: routeParams.pageNo?.toString(),
      listingStatus: routeParams.listingStatus?.toString(),
      searchTerm: routeParams.searchTerm ?? undefined,
    };
  },
  routeParamsParser: routeParamsString => {
    return {
      pageNo: parseRouteParamToInt(routeParamsString.pageNo) || DEFAULT_PAGE_NO,
      listingStatus:
        parseRouteParamToEnum(
          routeParamsString.listingStatus,
          MyListingStatus,
        ) || DEFAULT_LISTING_STATUS,
      searchTerm: routeParamsString.searchTerm || DEFAULT_SEARCH_TERM,
    };
  },
});
